module.exports = __webpack_public_path__ + "img/02.ed31948a.jpg";